import React from 'react';
import classNames from 'classnames';
import CustomButton from '../../components-library/buttons/CustomButton';
import PlusIcon from '../../assets/logo/PlusIcon';
import { CompiledProduct } from '../../providers/MenuProvider';
import useConfig from '../../hooks/ui/useConfig';
import { ProductInterface } from '../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';
import useTheme from '../../hooks/ui/useTheme';
import ThumbUpIcon from '../../modules/mobile/assets/icons/ThumbUpIcon';
import classnames from 'classnames';

type Props = { product: CompiledProduct; onClick: () => void };

const OfferProduct = ({ product, onClick }: Props) => {
  const { logo_url } = useConfig();
  const { t } = useTranslation(null, { keyPrefix: 'Modals:OfferModal' });

  return (
    <article
      className={classnames('h-full overflow-hidden relative flex flex-col rounded-lg border', {
        'cursor-pointer': !!onClick,
      })}
      onClick={onClick}
    >
      <BestSeller product={product} />
      <img
        src={product.thumbnail_url ?? logo_url}
        alt={product.name}
        className={classNames('object-cover w-full aspect-square', {
          'size-full !object-contain bg-brand-card': !product.thumbnail_url,
        })}
      />
      <div className="p-md justify-between flex flex-col h-full space-y-md">
        <p className="font-normal text-[15px] text-brand-text-primary line-clamp-1">{product.name}</p>
        {!!onClick && (
          <CustomButton
            customIcon={<PlusIcon className="mr-1 size-sm" color="white" />}
            className="h-9 !m-0 text-white text-sm"
          >
            {t('buttons.add')}
          </CustomButton>
        )}
      </div>
    </article>
  );
};

const BestSeller = ({ product }: { product: ProductInterface }) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:MultiSelectMenuItems' });
  const theme = useTheme();

  if (!product.popularity_rank) {
    return null;
  }

  return (
    <div className="flex gap-x-1 font-medium text-xs items-center justify-start absolute top-3 left-3 bg-brand-card rounded-lg lg:px-2 px-1 py-1 shadow-icon dark:shadow-none">
      <ThumbUpIcon color={theme.color.brand.primary} className="lg:h-5 lg:w-5 h-4 w-4" />
      <p className="lg:text-xs text-2xs font-medium">{t('labels.most_popular', { rank: product?.popularity_rank })}</p>
    </div>
  );
};

export default OfferProduct;
